// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Select, Typography } from "antd";
import { notify } from "@/shared/utils/notify";
import { useEffect, useState } from "react";
import { Controller, FieldErrorsImpl } from "react-hook-form";
import { InputError } from "./styled";
import { getService } from "../../../services";

const { Option } = Select;
const { Text } = Typography;

interface Props {
  dataOptions?: { value: string | number; title: string }[];
  width?: string;
  label: string;
  name: string;
  control: any;
  showSearch?: boolean;
  defaultValue?: string;
  isClearable?: boolean;
  service?: string;
  keyValue?: string;
  keyLabel?: string;
  placeholder?: string;
}

interface PropsContent {
  errors: Partial<
    FieldErrorsImpl<{
      [x: string]: any;
    }>
  >;
  name: string;
}

const ErrorComponent = ({ errors, name }: PropsContent) => {
  useEffect(() => {
    if (errors?.[name]?.message) {
      notify.error(`${errors?.[name]?.message}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);
  return (
    <>{!!errors[name] && <InputError>{errors?.[name]?.message}</InputError>}</>
  );
};

export const InputSelect = ({
  width = "100%",
  dataOptions = [],
  label,
  name,
  control,
  showSearch = false,
  defaultValue,
  isClearable = false,
  service,
  keyValue = "id",
  keyLabel = "name",
  placeholder,
}: Props) => {
  const [serviceOptions, setServiceOptions] = useState<any[]>([]);

  useEffect(() => {
    if (service) {
      const serviceInstance = getService(service);
      serviceInstance
        .find({})
        .then((data) => {
          const options = data.data.map((item) => ({
            value: item[keyValue],
            title: item[keyLabel],
          }));
          setServiceOptions(options);
        })
        .catch((error) => {
          console.error("Error fetching service options:", error);
        });
    }
  }, [service, keyValue, keyLabel]);

  const options = service ? serviceOptions : dataOptions;

  return (
    <Controller
      shouldUnregister
      control={control}
      name={name}
      render={({ field: { onChange, value }, formState: { errors } }) => {
        return (
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: 8 }}
          >
            {label && (
              <Text style={{ fontSize: 14, fontWeight: 500, marginBottom: 6, color: "#262626", display: "block" }}>
                {label}
              </Text>
            )}
            <Select
              placeholder={placeholder ?? label}
              value={!!value ? `${value}` : undefined}
              style={{ width, borderRadius: 6 }}
              defaultValue={!!defaultValue ? `${defaultValue}` : undefined}
              showSearch={showSearch ? true : false}
              optionFilterProp="children"
              onChange={onChange}
              allowClear={isClearable}
              onClear={() => onChange(null)}
            >
              {options &&
                options.length > 0 &&
                options.map((item, idx) => (
                  <Option value={item.value} key={idx + ""}>
                    {item.title}
                  </Option>
                ))}
            </Select>
            <ErrorComponent errors={errors} name={name} />
          </div>
        );
      }}
    />
  );
};
